import { Circle } from "@mui/icons-material";
import { Typography, useTheme, Box } from "@mui/material";
import { t } from "i18next";

interface heatMapProps {
  item: any;
}

const HeatMapDialog = (heatMapProps: heatMapProps) => {
  const circleColors = [
    "#FEFA63",
    "#F3AF4A",
    "#EC6A33",
    "#E93C27",
    "#EA3424",
    "#091CED",
    "#1940EE",
    "#316FF1",
    "#51B3F5",
    "#74FBFD",
  ];

  const colorWithLabel = (index: number) => {
    console.log(heatMapProps.item);
    const offset =
      index < 5
        ? heatMapProps.item?.value?.maxHeightOffset
        : heatMapProps.item?.value?.minHeightOffset;
    const value = !isNaN(offset)
      ? ((offset / 4) * (index < 5 ? index : 10 - (index + 1))).toFixed(3)
      : "-";

    return (
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Circle
          sx={{ color: circleColors[index], width: "18px", height: "18px" }}
        />
        <Typography sx={{ lineHeight: "1.0" }}>{`${value} m`}</Typography>
      </Box>
    );
  };

  return (
    <Box sx={{ display: "flex", border: "1px solid black" }}>
      <Box
        sx={{
          width: "120px",
          padding: "0px 4px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Typography sx={{ lineHeight: "1.0", fontSize: "12px" }}>
          {t("EXCAVATION")}
        </Typography>
        {[0, 1, 2, 3, 4].map((value) => colorWithLabel(value))}
      </Box>
      <Box
        style={{
          width: "120px",
          padding: "0px 4px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Typography sx={{ lineHeight: "1.0", fontSize: "12px" }}>
          {t("EMBANKMENT")}
        </Typography>
        {[5, 6, 7, 8, 9].map((value) => colorWithLabel(value))}
      </Box>
    </Box>
  );
};

export default HeatMapDialog;
